import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDrag } from 'react-dnd';
import moment from 'moment';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const InboxData = ({
    item,
    getTaskMailIndbox,
    onCheckboxClick,
    isShiftPressedMail,
    setIsShiftPressedMail,
    taskList,
    onDragEnd, // Prop to notify AppViewer of drag events
    filterList,
    role,
    selectedEmailsIds,
    handleChange,
    selectedMailId,
    setSelectedMailId,
    // deadlineDate,
    // selectedBoardId,
    // selectedBoardId
}) => {
    const [isHovered, setIsHovered] = useState(false);
    const [isSelectedMail, setIsSelectedMail] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });
    const [isUnread, setIsUnread] = useState(item?.isUnread || false);
    const navigate = useNavigate();
    const [isMailSelected, setIsMailSelected] = useState(false);
    const [mailId, setMailId] = useState(false);

    const { deadlineDate, selectedBoardId } = useSelector(
        (state) => ({
            deadlineDate: state.redux.deadlineDate,
            selectedBoardId: state.redux.selectedBoardId,
        }),
        (prev, next) => prev.deadlineDate === next.deadlineDate && prev.selectedBoardId === next.selectedBoardId,
    );

    const [{ isDragging }, drag, preview] = useDrag(
        {
            type: !isShiftPressedMail ? 'task' : 'childTask',
            item: !isShiftPressedMail
                ? {
                      id: item?.gmailMessageId,
                      gmailMessage: item?.gmailMessageId,
                      isShiftPressed: isShiftPressedMail,
                      subThreadId: item?.subEmail?.subThreadId,
                      subject: item?.subject,
                  }
                : { isShiftPressed: isShiftPressedMail, item, taskForCreate: true },
            collect: (monitor) => ({
                isDragging: !!monitor.isDragging(),
            }),
            end: (draggedItem, monitor) => {
                // Only call onDragEnd if drop was successful
                if (monitor.didDrop()) {
                    onDragEnd(item?.gmailMessageId);
                } else {
                    // Don't call onDragEnd for failed drops to keep the item in the original list
                }
            },
        },
        [isShiftPressedMail, onDragEnd, selectedBoardId],
    );

    const handleClick = async (event, id, item) => {
        if (
            event.target.closest('.bi.bi-trash') ||
            event.target.closest('.bi.bi-file-arrow-down') ||
            event.target.closest('.bi.bi-clock')
        ) {
            return;
        }
        // Clear previous selection

        // Set new selection
        setIsMailSelected(true);
        setIsSelectedMail(true);

        try {
            // const response = await axios.get(
            //     `${process.env.REACT_APP_BACKEND_URL}/email/emailStatus/${item?.gmailMessageId}`,
            // );
            // setIsUnread(response?.data?.messageRead === 'unread');
        } catch (error) {
            console.error('Error fetching email status:', error);
        }
        await updateStatusTask(item?.gmailMessageId, 'read');
        setSelectedMailId(item.gmailMessageId);
        // navigate('/mailinbox', { state: { selectedMail: item } });
    };

    const deleteTaskMail = async (id) => {
        const data = {
            taskstatus: 'inProgress',
        };
        try {
            const response = await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/email/deletemail/${id}`, {
                data,
            });
            if (response) {
                await getTaskMailIndbox();
            }
        } catch (error) {
            console.error('Error deleting task email:', error);
        }
    };

    const updateStatusTask = async (gmailMessageId, status) => {
        const data = {
            messageRead: status,
        };
        try {
            const response = await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/email/updatedMessageRead/${gmailMessageId}`,
                data,
            );
            if (response) {
                await getTaskMailIndbox();
            }
        } catch (error) {
            console.error('Error updating task status:', error);
        }
    };

    const handleCheckboxChange = () => {
        onCheckboxClick();
    };

    const handleContextMenu = (event) => {
        event.preventDefault();
        setPopupPosition({ x: event.clientX, y: event.clientY });
        setShowPopup(true);
    };

    const handlePopupClose = () => {
        setShowPopup(false);
    };

    const handleMarkAsUnread = async () => {
        await updateStatusTask(item?.gmailMessageId, 'unread');
        setIsUnread(true);
        handlePopupClose();
    };

    const handleMarkAsRead = async () => {
        await updateStatusTask(item?.gmailMessageId, 'read');
        setIsUnread(false);
        handlePopupClose();
    };
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.popup')) {
                handlePopupClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (item.isNew) {
            const timer = setTimeout(() => {
                const element = document.getElementById(item.id);
                if (element) {
                    element.classList.remove('blinking-effect');
                }
            }, 5000); // Stop blinking after 5 seconds
            return () => clearTimeout(timer);
        }
    }, [item.isNew, item.id]);
    return (
        <div
            id={item.id}
            className={`${item.isNew ? 'blinking-effect' : ''}`}
            ref={(node) => drag(node)}
            style={{ opacity: isDragging ? 0.5 : 1 }}
        >
            {/* <div>
                    {filterList && role != 'User' && (
                        <div className="drop-header">
                            <MultiSelect
                                options={filterList}
                                value={selectedEmailsIds}
                                onChange={handleChange}
                                labelledBy="Select Emails"
                            />
                        </div>
                    )}
                </div> */}
            <div
                key={item.id}
                onClick={async (e) => {
                    await updateStatusTask(item?.gmailMessageId, 'read');
                    navigate(`/detail/${item.id}`, {
                        state: {
                            selectedMail: item,
                            deadlineDate: deadlineDate,
                            taskID: item.id,
                            clickMailTask: true,
                            type: 'Gmail',
                            openTaskDataSidebar: true,
                            currentTask: item,
                            boardId: selectedBoardId,
                        },
                    });
                }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                onContextMenu={handleContextMenu}
                style={{
                    borderLeft: mailId ? '5px solid #1B72E8' : '5px solid transparent',
                    backgroundColor: isHovered ? '#fafafa' : 'white',
                }}
                className={`max-w-sm p-2 hover:bg-[#FAFAFA] ${
                    item?.subEmail?.messageRead === 'unread' || item?.messageRead === 'unread'
                        ? 'active-bg'
                        : 'bg-white'
                }`}
            >
                <div className="grid grid-cols-[8%_auto] items-start gap-1">
                    <div className="h-[26px]">
                        {/* <div
                            onMouseEnter={() => setIsShiftPressedMail(true)}
                            onMouseLeave={() => setIsShiftPressedMail(false)}
                            data-no-popup
                            style={{ cursor: 'pointer' }}
                        >
                            <img src="assets/copy.svg" alt="copy" />
                        </div> */}
                        {/* <div>
                            <input
                                type="checkbox"
                                className="!shadow-none text-[15px]"
                                onChange={handleCheckboxChange}
                                onClick={(e) => e.stopPropagation()}
                            />
                        </div> */}
                    </div>
                    <div className="relative">
                        <div className="grid grid-cols-[70%_auto] items-center text-black">
                            <h2
                                className={`text-ellipse h-[26px] text-[13.6px] ${
                                    item?.subEmail?.messageRead === 'unread' || item?.messageRead === 'unread'
                                        ? 'font-bold'
                                        : 'font-normal'
                                }`}
                            >
                                {item?.subEmail?.subject || item?.subject || 'No Subject'}
                            </h2>
                            <div className="h-[26px]">
                                {/* {isHovered && ( */}
                                {/* <div className="flex justify-end items-center">
                                    <span
                                        className={`date-time text-black ${
                                            item?.subEmail?.messageRead === 'unread' || item?.messageRead === 'unread'
                                                ? 'font-bold text-[11.56px]'
                                                : 'font-normal'
                                        }`}
                                    >
                                        {item?.subEmail?.createdAt
                                            ? moment(item.subEmail.createdAt).format('MMM DD')
                                            : item?.createdAt
                                            ? moment(item.createdAt).format('MMM DD')
                                            : 'No Date'}
                                    </span>
                                </div> */}
                                <div className="text-right">
                                    <span
                                        className={`date-time text-black ${
                                            item?.subEmail?.messageRead === 'unread' || item?.messageRead === 'unread'
                                                ? 'font-bold text-[11.56px]'
                                                : 'font-normal'
                                        }`}
                                    >
                                        {item?.subEmail?.createdAt
                                            ? moment(item.subEmail.createdAt).format('MMM DD')
                                            : item?.createdAt
                                            ? moment(item.createdAt).format('MMM DD')
                                            : 'No Date'}
                                    </span>
                                </div>
                                {/* )} */}
                            </div>
                        </div>
                        <div className="grid grid-cols-[70%_auto] items-center text-ellipsis !text-[13.6px]">
                            <h6
                                className={`text-black ${
                                    item?.subEmail?.messageRead === 'unread' || item?.messageRead === 'unread'
                                        ? 'font-bold'
                                        : 'font-normal'
                                }`}
                            >
                                {item?.subEmail?.name || item?.name || 'Unknown Sender'}
                            </h6>

                            <div className="flex gap-[8px] justify-end items-center">
                                {(item?.subEmail?.messageRead === 'unread' || item?.messageRead === 'unread') && (
                                    <div className="unread-red-dot"></div>
                                )}
                                {/* <div className="circle-user circle-none text-white">
                                    {item?.name?.charAt(0)?.toUpperCase() || '?'}
                                </div> */}
                                {/* <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-star"
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.56.56 0 0 0-.163-.505L1.71 6.745l4.052-.576a.53.53 0 0 0 .393-.288L8 2.223l1.847 3.658a.53.53 0 0 0 .393.288l4.052.575-2.906 2.77a.56.56 0 0 0-.163.506l.694 3.957-3.686-1.894a.5.5 0 0 0-.461 0z" />
                                </svg> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {showPopup && (
                <div
                    className="popup absolute z-10 p-1 bg-[#f5f5f5] border shadow-lg rounded-[4px] !text-[11.56px]"
                    style={{ top: popupPosition.y, left: popupPosition.x }}
                >
                    {item?.messageRead === 'unread' && (
                        <button onClick={handleMarkAsRead} className="block px-2 py-1 text-black">
                            Mark as Read
                        </button>
                    )}
                    {item?.messageRead === 'read' && (
                        <button onClick={handleMarkAsUnread} className="block px-2 py-1 text-black">
                            Mark as Unread
                        </button>
                    )}
                    <button onClick={() => deleteTaskMail(item?.id)} className="block px-2 py-1 text-red-500">
                        Delete
                    </button>
                </div>
            )}
        </div>
    );
};

InboxData.propTypes = {
    item: PropTypes.object.isRequired,
    getTaskMailIndbox: PropTypes.func.isRequired,
    onCheckboxClick: PropTypes.func.isRequired,
    isShiftPressedMail: PropTypes.bool,
    setIsShiftPressedMail: PropTypes.func,
    taskList: PropTypes.array,
    onDragEnd: PropTypes.func.isRequired,
    selectedMailId: PropTypes.string,
    setSelectedMailId: PropTypes.func,
};

export default InboxData;
